export default "__VITE_ASSET__DUgO7EXp__"